const M = {
    account: {
        id:          '',
        description: '',
    },
    network: {
        id:             '',
        name:           '',
        url:            '',
        reportOn:       0,
        reportToName:   '',
        reportTo:       '',
        reportCc:       '',
        reportMessage:  '',
        proprietary:    'private',
        notifyEmail:    '',
        notifyRatingOn: 0,
        client:         0,
        city:           '',
        phone:          '',
        registryPhone:          '',
        // phoneExt:       '',
        email:          '',
        website:        '',
        socialVk:        '',
        socialFb:        '',
        socialInsta:     '',
        socialOk:        '',
        socialYoutube:   '',
        socialTg:   '',
        socialWhatsApp:   '',
        description:    '',
        img:            '',
        imgOriginalPath:    '',
        clinics:        [],
    },
    user:  {},
    users: [],
    subscriptions: [],
    hasActiveSubscription: false,
}

export function GET_DEFAULT_M () { return JSON.parse(JSON.stringify(M));}
export function  initialState() { return JSON.parse(JSON.stringify(
    {
        M: M,
        actionType: '',
        urlAvailable:   true,
        loginAvailable: true,
        foundClinics: [],
        registryPhoneError: null,
        doctuPhoneError: null,
        whatsAppPhoneError: null,
        clinicSearchRequest: null,
        deletedSubscriptions: [],
    }
));}
